/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import PodiumListItem from './PodiumListItem';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class SelfRankCard extends Component {
	oninit(vnode) {
		super.oninit(vnode);
		this.refresh();
	}

	view() {
		if (this.rank === 0) {
			return null;
		}

		if (!this.rank) {
			return <LoadingIndicator />;
		}

		return (
			<div className="SelfRankCard">
				<PodiumListItem user={app.session.user} position={this.rank} positionClass="first" />
			</div>
		);
	}

	refresh() {
		app.store
			.find(`gamilytics/userRank/${app.leaderboard.activityType}`, app.session.user.id(), app.leaderboard.requestParams())
			.then((rank) => {
				this.rank = rank.rank();

				// Set the activity summary value for the user
				app.session.user.data.attributes.activitySummary = rank.activitySummary();

				m.redraw();
			})
			.catch(() => {
				this.rank = 0;
				m.redraw();
			});
	}
}
